module.exports = __webpack_public_path__ + "static/media/FestivalTeam1.693316c2.JPG";